import Header from './components/Header';
import Hero from './components/Hero';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import FAQSection from './components/FAQSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FeaturesSection />
        <RankingSection />
        <FAQSection />
        <CommentsSection />
        <CardsSection />
        <MediaSection />
        <CarouselSection />
        <TopicsSection />
        <ContactSection />
        <AboutSection />
        <UpdatesSection />
        <IndexSection />
        <AppSection />
      </main>
      <Footer />
    </>
  );
}